import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ServiceGrid from "./sections/ServiceGrid";
import ServiceDetails from "./sections/ServiceDetails";
import BathroomRemodelFaq from "./sections/BathroomRemodelFaq";
import FinalQuoteCta from "./sections/FinalQuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Hero />
      <ServiceGrid />
      <ServiceDetails />
      <BathroomRemodelFaq />
      <FinalQuoteCta />
      <Footer />
    </div>;
}